export const dataTableFieldMessages = {
  'Loading table data...': 'formforge.preview.data_table.loading',
  'Error loading table data:': 'formforge.preview.data_table.error_prefix',
  'No data available': 'formforge.preview.data_table.no_data',
  Ascending: 'formforge.preview.data_table.sort_ascending',
  Descending: 'formforge.preview.data_table.sort_descending',
} as const;

export const previewFieldMessages = {
  Confirm: 'formforge.preview.password.confirm_label',
  'Generate for me': 'formforge.preview.password.generate_for_me',
  'Type again to confirm': 'formforge.preview.password.type_again_to_confirm',
  'Confirm password is required': 'formforge.preview.password.confirm_required',
  'Passwords do not match': 'formforge.preview.password.passwords_do_not_match',
} as const;

export type DataTableFieldMessageKey = keyof typeof dataTableFieldMessages;
export type PreviewFieldMessageKey = keyof typeof previewFieldMessages;

export {
  type ExternalLinkWarningMessageKey as TermsExternalLinkMessageKey,
  externalLinkWarningMessages as termsExternalLinkMessages,
} from '../../../../shared/components/ExternalLinkWarningModal/externalLinkWarningMessages';

export const dropdownSearchMessages = {
  'Searching...': 'formforge.preview.dropdown.searching',
  'No matches. Try a different search.':
    'formforge.preview.dropdown.no_matches',
} as const;

export type DropdownSearchMessageKey = keyof typeof dropdownSearchMessages;
